import React from 'react'
import List from 'scripts/components/list/List'
import { soompi } from 'scripts/api/SoompiApi'
import ClientErrors from 'scripts/lib/ClientErrors'
import locale, {getLang} from 'shared/i18n/react'

class SideBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {related: []}
    this.lang = getLang()
  }

  componentDidMount() {
    const { postId, relatedTag } = this.props
    const tagId = relatedTag ? relatedTag.id : false
    const subType = relatedTag ? relatedTag.type : ''
    const page = 1
    const perPage = 7
    if (tagId && subType !== '') {
      this.getTopicPromise = soompi.setLanguage(this.lang).getTopic(subType)({id: tagId, perPage, page})
      this.getTopicPromise.promise.then((topic) => {
        const posts = topic.results.filter((item) => {
          if (item.id !== postId) { return true }
        })
        this.setState({related: posts})
      }).catch((e) => {
        // There must be a fallback here
        ClientErrors({
          message: 'SideBar: Topic fetch failed.',
          error: e
        })
      })
    }
  }

  componentWillUnmount() {
    if (this.getTopicPromise) {
      this.getTopicPromise.cancel()
    }
  }

  render() {
    const { related } = this.state
    if (related.length > 0) {
      return (
        <div className="article-sidebar">
          <List
            data={related}
            title={locale.general.related}
            titleArrow={false}
            sizeLeft={6}
            sizeRight={6}
            showassoc={true}
            showdate={true}
            limit={6}
            section="recommendations"
          />
        </div>
      )
    } else {
      return null
    }
  }
}

export default SideBar



// WEBPACK FOOTER //
// ./assets/js/components/article/SideBar.jsx